<template lang="html">
  <NuxtLink
    v-if="to !== '#'"
    :to="to"
    class="text-primary hover:underline"
    target="_blank"
    rel="noopener noreferrer"
  >
    <slot />
  </NuxtLink>
  <a
    v-else
    href="#"
    class="text-primary hover:underline"
    @click.prevent
  >
    <slot />
  </a>
</template>

<script setup lang="ts">
defineProps<{
  to: string
}>()
</script>
